<qm-train-alarm-actions
  [tripNumber]="tripNumber"
  [trainDate]="tripDate"
  [trainCategory]="trainCategory"
  [ngbTooltip]="'Open train info' | translate">
</qm-train-alarm-actions>